import { ArrowLeft, ArrowRight, ClipboardList, Repeat2 } from "lucide-react";
import { Link } from "react-router-dom";
import { REGULAR_TASKS } from "@/pages/regularTasks";

export default function RegularTaskList() {
  return (
    <div className="acct-wrap regular-task-page" data-testid="task-reguler-list-page">
      <Link className="regular-task-back" to="/kipk/manajemen-task" data-testid="task-reguler-back-to-management">
        <ArrowLeft size={15} /> Kembali ke Manajemen Task
      </Link>

      <header className="regular-task-header">
        <div>
          <div className="eyebrow"><Repeat2 size={12} /> TASK REGULER</div>
          <h2 data-testid="task-reguler-list-title">Daftar Task Reguler</h2>
        </div>
      </header>

      <section className="regular-task-list" data-testid="task-reguler-grid">
        {REGULAR_TASKS.map((task) => (
          <Link
            key={task.id}
            className="regular-task-item"
            to={`/kipk/manajemen-task/reguler/${task.id}`}
            data-testid={`task-reguler-open-${task.id}`}
          >
            <span className="regular-task-number">{String(task.order).padStart(2, "0")}</span>
            <span className="regular-task-icon"><ClipboardList size={19} /></span>
            <span className="regular-task-copy">
              <small>Task Reguler</small>
              <strong data-testid={`task-reguler-title-${task.id}`}>{task.title}</strong>
              <em data-testid={`task-reguler-status-${task.id}`}>Detail belum dikonfigurasi</em>
            </span>
            <span className="regular-task-arrow" aria-hidden="true"><ArrowRight size={18} /></span>
          </Link>
        ))}
      </section>
    </div>
  );
}